import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import GenericRoutes from "./Routes";
import { Link } from "react-router-dom";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";

function App() {
  //Smooth Scroll
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex-grow">
        <GenericRoutes />
      </div>
      <Link
        to={
          "https://api.whatsapp.com/send/?phone=%2B917736904688&text&type=phone_number&app_absent=0"
        }
        target="_blank"
      >
        <img
          src="/images/elements/whatsapp-logo.png"
          alt="whatsapp_logo"
          className="fixed bottom-[10px] right-[10px] w-12"
        />
      </Link>
      <Footer />
    </div>
  );
}

export default App;
